module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Db-Ec-Gc.402abd5c.png";